import React, { useEffect, useState } from 'react'
import { sitePolicy } from '../asiosConfig';
import { toast } from 'react-toastify';
import { Box, Container, Paper, Skeleton, Typography } from '@mui/material';
import Nav from './Nav';
import Footer from './Footer';
export const FraudAlert = () => {
    const [aboutUs, setAboutUs] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAboutUs = async () => {
            try {
                const response = await sitePolicy();
                if (response.status === 200 || response.status === 201) {
                    setAboutUs(response.data.data);


                } else {
                    toast.error('Failed to fetch about us data');
                }
            } catch (error) {
                toast.error('Failed to fetch about us data');
            } finally {
                setLoading(false);
            }
        };
        fetchAboutUs();
    }, []);
    return (
        <Box>
            <Nav />
            <Box mt={12}>
                <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
                    <Paper elevation={6} sx={{ p: 4, mb: 6, width: '80%', mx: 'auto' }}>
                        <Box textAlign="center" mb={12} mt={5}>

                            {loading ? (
                                <Skeleton variant='rectangular' height={200} />
                            ) : (
                                <>
                                    <Typography
                                        variant="h4"
                                        component="h3"
                                        gutterBottom
                                        sx={{ fontFamily: "Montserrat" }}
                                    >
                                        IND Matrimony Fraud Alert
                                    </Typography>
                                    <div className='text-left' dangerouslySetInnerHTML={{ __html: aboutUs.fraud_alert }} />
                                </>
                            )}
                        </Box>
                    </Paper>
                </Container>
            </Box>
            <Footer />
        </Box>
    )
}
